import React from 'react';
import PropTypes from 'prop-types';
import { InfoPopover } from '@unite-us/client-utils';
import '../stylesheets/communicationTypeInfoIcon.scss';
var CommunicationTypeInfoIcon = function CommunicationTypeInfoIcon(_ref) {
  var className = _ref.className,
    id = _ref.id,
    popoverContent = _ref.popoverContent;
  if (!popoverContent) {
    return null;
  }
  return /*#__PURE__*/React.createElement(InfoPopover, {
    className: "communication-type-info-icon ".concat(className),
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "communication-type-info-icon__popover-content"
  }, popoverContent));
};
CommunicationTypeInfoIcon.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  popoverContent: PropTypes.node
};
CommunicationTypeInfoIcon.defaultProps = {
  className: '',
  popoverContent: ''
};
export default CommunicationTypeInfoIcon;
//# sourceMappingURL=CommunicationTypeInfoIcon.js.map